export const toolBarTheme = {
    styleOverrides: {
        root: {
            minHeight: '0px !important',
        },
    },
};
